import React from 'react';
import { useNavigate } from 'react-router';
import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { Api } from '@core/api';
import { links } from '@core/router';
import { injectTSDI } from '@core/tsdi';
import { UpdateCompositePointDefinitionRequestDto } from '@api/FitnessActivityClient';

export function useEditPointDefinitionStore(
    communityId: number,
    definitionId: number
) {
    const { fitnessActivityClient } = injectTSDI(Api);
    const navigate = useNavigate();

    const getDefinition = useWrapRequest(
        async () => {
            const result = await fitnessActivityClient.admin
                .compositePointDefinitionControllerGetById(definitionId);
            return result.data;
        },
        { defaultData: null }
    );

    React.useEffect(() => {
        getDefinition.request([]);
    }, [definitionId]);

    const updateRequest = useWrapRequest(
        async (data: UpdateCompositePointDefinitionRequestDto) =>
            fitnessActivityClient.admin.compositePointDefinitionControllerUpdate(
                definitionId,
                data
            ),
        { successMessage: () => 'Point definition updated successfully' }
    );

    const onSubmit = async (data: UpdateCompositePointDefinitionRequestDto) => {
        const response = await updateRequest.request([data], { throwError: true });
        if (response) {
            navigate(links.communityPointDefinitions(String(communityId)));
        }
    };

    return { getDefinition, updateRequest, onSubmit };
}
